import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfterSlider({ before, after, label }) {
  const ref = useRef(null);
  const [pct, setPct] = useState(50);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPct(p);
  }, []);

  useEffect(() => {
    const move = (e) => {
      if (!dragging.current) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      setFromClientX(x);
    };
    const up = () => (dragging.current = false);
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchend", up);
    };
  }, [setFromClientX]);

  const start = (e) => {
    dragging.current = true;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(x);
  };

  return (
    <div className="select-none">
      {label && <div className="font-display font-semibold text-[#0f2740] mb-3">{label}</div>}
      <div
        ref={ref}
        onMouseDown={start}
        onTouchStart={start}
        className="relative w-full h-[420px] rounded-2xl overflow-hidden cursor-ew-resize shape-soft"
      >
        <img src={after} alt="After renovation" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pct}%` }}>
          <img src={before} alt="Before renovation" className="absolute inset-0 h-full object-cover max-w-none" style={{ width: ref.current?.offsetWidth || "100%" }} draggable={false} />
          <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#0f2740]/80 text-white text-xs font-semibold">BEFORE</span>
        </div>
        <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#2f9fe6] text-white text-xs font-semibold">AFTER</span>
        <div className="absolute top-0 bottom-0 w-1 bg-white shadow-lg" style={{ left: `${pct}%`, transform: "translateX(-50%)" }}>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-xl flex items-center justify-center">
            <MoveHorizontal className="w-5 h-5 text-[#0f2740]" />
          </div>
        </div>
      </div>
    </div>
  );
}
